export default __webpack_public_path__ + "static/styles-dropdown-legacy-539b16dc4ef8487a8fbb3c310f76906a.png";